import useSecuritiesCredentialStore from 'global/Securities/stores/useSecuritiesCredentialStore';

export default function useIsSecuritiesMainAccount() {
  const accountNumber = useSecuritiesCredentialStore((s) => s.accountNumber);
  const mainAccountNumber = useSecuritiesCredentialStore((s) => s.mainAccountNumber);

  return accountNumber === mainAccountNumber;
}
